 
 import { InlinePath } from "./paths"
 

export const line_types = {
  inline: InlinePath
}

export const generateLineChartSettings = ({ chart_settings = {}, ...props}: Record<string, unknown>): Record<string, unknown> => {
 
 

  const new_props = {
    ...props,
    chart_settings: {
      size: .5,
      styles: 'default',
      ...( chart_settings || {})
    }
  }
 
 
  return new_props || {}
}


export const LineCharts = ({
  line_data_type = 'value-key',
  ...in_props
}: Record<string, unknown>): JSX.Element => {
  
  const { 
    chart_ref,
    toggleTooltip,
    tooltip_ref,
    line_type,
    width,
    height, 
    ...props 
  } = generateLineChartSettings(in_props || {}) || {}

  const LinePath = line_types[line_type || 'inline'] || (() => <text>invalid line type: {line_type || 'undefined'}</text>)
 
 

  return <>

    <svg width='100%' height='100%'>
      <LinePath {...props}/>
    </svg>
 
  </>
}
 